import { createApiAction } from '@app/packages/api/utils'
import type { ApiReferral } from '@app/packages/api/v2/types/entities'

export const getReferrals = () =>
  createApiAction('getReferrals', dispatch => dispatch<{ data: ApiReferral[] }>({ method: 'GET', endpoint: '/api/v2/referrals' }))
